import { render, staticRenderFns } from "./CharacterProperties.vue?vue&type=template&id=7825b50d&scoped=true"
import script from "./CharacterProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./CharacterProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CharacterProperties.vue?vue&type=style&index=0&id=7825b50d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825b50d",
  null
  
)

export default component.exports